import { Button, Typography } from '@breetometer/components';

import type { ITransactionMobileColumnLeft } from '../TransactionsMobileColumn.helpers';

const MobileColumnLeft = ({ value, date, onClick, children }: ITransactionMobileColumnLeft) => (
	<Button
		variant='native'
		className='datatable_mobilecolumnleft'
		onClick={onClick}
	>
		{children ?? (
			<>
				<Typography
					as='h6'
					className='color-neutral-50'
				>
					{value}
				</Typography>
				<Typography className='color-primary-100'>{date}</Typography>
			</>
		)}
	</Button>
);

export default MobileColumnLeft;
